const FilesMixin = {
  methods: {
    convertFileToBase64WithName(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()

        reader.readAsDataURL(file)

        reader.onload = () => {
          const result = {
            filename: file.name,
            base64: reader.result,
          }

          resolve(result)
        }

        reader.onerror = (error) => reject(error)
      })
    },
    async convertFiles(files) {
      const filesPathsPromises = files.map((file) =>
        this.convertFileToBase64WithName(file)
      )

      var filePaths = await Promise.all(filesPathsPromises)

      return filePaths
    },
    checkFileExtensionPdf(file) {
      var extension = file.substr((file.lastIndexOf('.') + 1));
      if (!/(pdf)$/ig.test(extension)) {
        return false;
      }
      return true;
    },
    sanitizeBase64(base64Str) {
      const base64StrRe = /^([A-Za-z0-9+\/]{4})*([A-Za-z0-9+\/]{4}|[A-Za-z0-9+\/]{3}=|[A-Za-z0-9+\/]{2}==)$/

      const sanitizedBase64 = this.removeDoubleQuotes(base64Str)
      if (sanitizedBase64.match(base64StrRe))
        return sanitizedBase64

      return ''
    },
    removeDoubleQuotes(str) {
      if (str == undefined || str == null)
        return ''

      return str.replaceAll('"', '')
    },
  }
}

export default FilesMixin